import React, { useContext } from 'react';

import Badge from 'components/Badge';
import Row from 'components/Common/Row';
import ContentLabels from 'components/ContentLabels';
import { UIVersionContext } from 'contextProviders/SplashScreenProviders/UserAndAccountProviders/UIVersionProvider';

const AfterReportNameBadge = ({ report }: { report: ReportType }) => {
  const { isV3 } = useContext(UIVersionContext);
  if (isV3) {
    return <ContentLabels labelIds={report.labelIds} />;
  }

  if (report.isMarkedAsSEOnly && report.isMarkedAsPopup) {
    return (
      <Row centerAlign style={{ gap: 8 }}>
        <Badge text={'SE Only'} badgeType={'Info'} />
        <Badge text={'Popup'} badgeType={'Default'} />
      </Row>
    );
  } else if (report.isMarkedAsPopup) {
    return <Badge text={'Popup'} badgeType={'Default'} />;
  } else if (report.isMarkedAsSEOnly) {
    return <Badge text={'SE Only'} badgeType={'Info'} />;
  }

  return null;
};

export default AfterReportNameBadge;
